import Item from './components/Item.vue';

export default {
  components: { Item },
  data() {
    return {
      tab: null,
      description: '',
      showDescID: false,
      dialog: {
        active: false,
        content: '',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
    archiveActions() {
      return this.$store.state.sales.archiveActions;
    },
  },
  methods: {
    showDesc(id) {
      const actions = this.actions.filter(item => item.id === id);
      if (this.showDescID === id) {
        this.description = '';
        this.showDescID = false;
      } else {
        this.showDescID = id;
        this.description = actions.length ? actions[0].description : '';
      }
    },
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
  },
  mounted() {
    this.$store.dispatch('sales/ClearAction');
    this.$store.dispatch('sales/ClearSale');
    this.$store.dispatch('sales/GetActiveActionsList', { profile_id: this.user.profile_id });
    this.$store.dispatch('sales/GetArchiveActionsList', { profile_id: this.user.profile_id });
  },
};
